import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var getDirections24Icon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 23.625a1.14 1.14 0 0 1-1.05-.705l-2.82-7.05-7.05-2.82A1.14 1.14 0 0 1 .375 12c.017-.471.33-.88.78-1.02L16.74 5.895a1.14 1.14 0 0 1 1.14.285c.3.298.404.74.27 1.14l-5.085 15.525c-.146.453-.56.765-1.035.78H12ZM4.815 12.12l4.605 1.83c.284.12.51.346.63.63l1.845 4.62L15.33 8.7 4.815 12.12Zm18.81-5.37A6.27 6.27 0 0 0 22.5 3.195 5.88 5.88 0 0 0 20.835 1.5 6.225 6.225 0 0 0 17.25.375a6.345 6.345 0 0 0-6.12 4.635l.87.24a1.5 1.5 0 0 0 1.71-.63 4.14 4.14 0 0 1 3.54-1.995 3.96 3.96 0 0 1 2.325.735c.435.283.803.656 1.08 1.095a3.9 3.9 0 0 1 .72 2.295 4.14 4.14 0 0 1-1.995 3.54 1.5 1.5 0 0 0-.63 1.71l.24.87a6.345 6.345 0 0 0 4.635-6.12Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { getDirections24Icon as default };
//# sourceMappingURL=getDirections24Icon.js.map
